import React from "react";
import { UserPlus, BookUser, Car, Users } from "lucide-react";

export default function HomeView({ onNewRecord, onOpenList, plakaCount, sakinCount }) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <button
          onClick={onNewRecord}
          className="bg-brand-600 hover:bg-brand-500 text-white aspect-square rounded-2xl font-bold text-sm shadow-lg shadow-brand-600/20 flex flex-col items-center justify-center gap-3 transition-colors active:scale-95 relative overflow-hidden"
        >
          <div className="absolute -right-4 -bottom-4 text-white/10 pointer-events-none">
            <UserPlus size={90} strokeWidth={1.2} />
          </div>
          <UserPlus size={30} className="relative z-10" />
          <span className="text-center px-2 leading-tight relative z-10">
            Yeni Kayıt
            <br />
            Oluştur
          </span>
        </button>

        <button
          onClick={onOpenList}
          className="bg-slate-800 hover:bg-slate-700 text-white aspect-square rounded-2xl font-bold text-sm shadow-lg flex flex-col items-center justify-center gap-3 transition-colors active:scale-95 border border-slate-700 relative overflow-hidden"
        >
          <div className="absolute -right-4 -bottom-4 text-slate-600/30 pointer-events-none">
            <BookUser size={90} strokeWidth={1.2} />
          </div>
          <BookUser size={30} className="text-brand-400 relative z-10" />
          <span className="text-center px-2 leading-tight relative z-10 text-slate-300">
            Kayıtlı
            <br />
            Kişiler
          </span>
        </button>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="bg-slate-800 border border-slate-700 p-4 rounded-xl flex items-center gap-3 shadow-md">
          <div className="bg-emerald-500/10 text-emerald-400 p-3 rounded-lg">
            <Car size={18} />
          </div>
          <div>
            <div className="text-xs text-slate-400">Kayıtlı Plaka</div>
            <div className="text-lg font-bold text-white">{plakaCount}</div>
          </div>
        </div>
        <div className="bg-slate-800 border border-slate-700 p-4 rounded-xl flex items-center gap-3 shadow-md">
          <div className="bg-blue-500/10 text-blue-400 p-3 rounded-lg">
            <Users size={18} />
          </div>
          <div>
            <div className="text-xs text-slate-400">Kayıtlı Sakin</div>
            <div className="text-lg font-bold text-white">{sakinCount}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
